export default "__VITE_ASSET__DT_a$QoQ__"